import { Navbar, Hero, Features, Footer } from '@shadeables/ui';
import styles from './Home.module.css';

export function Home() {
  return (
    <div className={styles.home}>
      <Navbar />
      <main className={styles.main}>
        <Hero />
        <Features />
      </main>
      <Footer />
    </div>
  );
}

export default Home;
